import React from 'react';
import PropTypes from 'prop-types';

const Article = props => {

    const {data, closeArticle} = props;
    const articleImg = {
        backgroundImage: `url('${data.article_img}')`,
    };

    const sourceIcon = {
        backgroundImage: `url('${data.source_icon}')`,
    };
    return (
        <div>
            <div className="close-article" onClick={closeArticle}/>
            <div className="dash__inner p4 relative dash__article" id={`news${data.id}`}>
                <h5 className="article__date">
                    <div className="article__srcIcon bg-center"
                         style={sourceIcon}/>
                    {/*{data.date}*/}
                </h5>
                <h2>{data.title}</h2>
                <div className="article__imageWrap mt2 mb2 bg-center"
                     style={articleImg}>
                    <svg className="aspect" viewBox="0 0 5 3">
                        <rect x="0" y="0" width="5" height="3"/>
                    </svg>
                </div>
                {data.content.map((content, index) => {
                    return <p key={index}>{content}</p>
                })}
            </div>
        </div>
    )

};

Article.propTypes = {
    data: PropTypes.object.isRequired,
    closeArticle: PropTypes.func.isRequired,
};

export default Article;
